'use strict';

var formValidation = require('./giftCertificateFormValidation');
var kleberEmailValidation = require('../kleber/kleberEmailValidation');

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostGiftCertAdd(response) {
    $('.minicart').trigger('count:update', response);

    if (response.error) {
        return;
    }

    if ($('.add-to-cart-messages').length === 0) {
        $('body').append('<div class="add-to-cart-messages"></div>');
    }

    $('.add-to-cart-messages').append(
        '<div class="add-to-basket-giftcert text-center" role="alert">'
        + response.message
        + '</div>'
    );

    setTimeout(function () {
        $('.add-to-cart-messages').remove();
    }, 5000);
}

/**
 * Clean form fields
 * @param {Object} $form - jQuery form object
 */
function cleanForm($form) {
    $form.find('input[type=text], input[type=email], input[type=number], textarea').val('');
    $form.find('.alert').remove();
}

/**
 * move error HTML5 message to different element
 */
function validateAmount() {
    var amountError = $('.invalid-feedback-amount-hidden').text();
    if (amountError) {
        $('.invalid-feedback-amount').text(amountError).css('display', 'inline-block');
    }
}

module.exports = function () {
    $('.gift-cert-msg-close').on('click', function () {
        $(this).closest('.gift-cert-balance-msg').addClass('d-none');
    });

    $('#amount-input').on('blur', function () {
        var $this = $(this);
        if ($this.hasClass('is-invalid')) {
            $('.invalid-feedback-amount').css('display', 'inline-block');
        } else {
            $('.invalid-feedback-amount').css('display', 'none');
        }
    });

    $('.buttons-giftcert').on('click', function () {
        var form = $('form.giftcert-purchase');
        var invalidFeedback = $('.js-fixed-amount-invalid-message');
        var update = invalidFeedback.siblings().hasClass('gift-line-item');
       
        if (!update) {
            if (!$('.giftCertificateAmountCta').hasClass('active')) {
                form.addClass('is-invalid');
                invalidFeedback.siblings().addClass('is-invalid');
                invalidFeedback.text('How much do you want to gift?');
            } else {
                form.removeClass('is-invalid');
                invalidFeedback.siblings().removeClass('is-invalid');
                invalidFeedback.text('');
            }
        }
    });

    $('form.giftcert-purchase').on('submit', function (e) {
        if ($(this).hasClass('is-invalid')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    });

    $('form.giftcert-purchase').submit(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('form.giftcert-purchase .btn-save-container button').attr('disabled', 'disabled');
        var form = $(this);

        if (!form[0].checkValidity()) {
            return false;
        }

        var url = form.attr('action');

        var emailField = $('form.giftcert-purchase #recipientEmail-input');

        kleberEmailValidation.isValidEmail(emailField).then(isValid => {
            if (isValid) {
                form.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        form.spinner().stop();
                        $('form.giftcert-purchase .btn-save-container button').removeAttr('disabled', 'disabled');
                        handlePostGiftCertAdd(data);
        
                        if (!data.success) {
                            formValidation(form, data);
                            validateAmount();
                        } else {
                            $('body').trigger('product:afterAddToCart', data);
                            cleanForm($('form.giftcert-purchase'));
        
                            // Reset the selected value (fixed or custom)
                            form.find('.js-giftCertificateAmount').removeClass('active');
                            form.find('#amount-input').val('');
                        }
        
                        if (data.success && data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        form.spinner().stop();
                    }
                });
            }
            $('form.giftcert-purchase .btn-save-container button').removeAttr('disabled', 'disabled');
        });
        return false;
    });

    $('form.js-giftcert-check-balance').submit(function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();

                var $checkBalanceNotification = $('.gift-cert-balance-msg');

                if (data.error) {
                    $checkBalanceNotification
                        .addClass('alert-danger')
                        .removeClass('alert-info')
                        .find('.resultMessage')
                        .html(data.errorMessage);

                    setTimeout(function () {
                        // Prevent hiding the container if the content of the message has changed to "alert-info"
                        if ($checkBalanceNotification.hasClass('alert-danger')) {
                            $checkBalanceNotification.addClass('d-none');
                        }
                    }, 5000);
                } else {
                    $checkBalanceNotification
                        .addClass('alert-info')
                        .removeClass('alert-danger')
                        .find('.resultMessage')
                        .html(data.balanceMessage)
                        .removeClass('d-none');
                }

                // Make the container visible after all data inside is set
                $checkBalanceNotification.removeClass('d-none');
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                form.spinner().stop();
            }
        });
        return false;
    });

    $('.js-giftCertificateAmount').click(function (e) {
        e.preventDefault();
        var currentElement = $(this);

        // Remove the selected status class from all buttons and add it only to the current
        currentElement.closest('.row').find('.js-giftCertificateAmount, .js-otherGiftCertificateAmount').removeClass('active');
        currentElement.addClass('active');

        var amount = parseInt(currentElement.data('amount'), 10);
        $('#amount-input').val(amount);
        $('.gift-certificate-amount-row').addClass('d-none');
    });

    $('.js-otherGiftCertificateAmount').click(function (e) {
        e.preventDefault();
        var currentElement = $(this);

        // Remove the selected status class from all buttons and add it only to the current
        currentElement.closest('.row').find('.js-giftCertificateAmount').removeClass('active');
        currentElement.addClass('active');

        $('#amount-input').val('');
        $('.gift-certificate-amount-row').removeClass('d-none');
    });

    if ($(window).width() > 1440) {
        $('#message-input').attr('placeholder', 'Please enter your message..');
    }

    // Hide gift pin initial and show when gift cert code leghth >= 6
    $(document).ready(function () {
        var giftCertPinHolder = $('#giftCertPinHolder');
        var giftCertCode = $('#giftCertCode');
        giftCertPinHolder.hide();

        giftCertCode.keyup(function () {
            if (this.value.length >= 6) {
                giftCertPinHolder.show();
            } else {
                giftCertPinHolder.hide();
            }
        });
    });
};

// Gift certificate Balance Message
$('#btnGiftCertCheckBalance').off('click').on('click', function (e) {
    e.preventDefault();
    var $form = $('.js-giftcert-check-balance');
    var submitUrl = $(this).data('url');

    $.ajax({
        url: submitUrl,
        method: 'POST',
        data: $form.serialize()
    }).done(function (data) {
        var $giftCertBalanceMsg = $('.gift-cert-balance-msg');

        $giftCertBalanceMsg.removeClass('d-none');

        if (data.error) {
            $giftCertBalanceMsg
                .addClass('alert-danger')
                .removeClass('alert-info')
                .find('.resultMessage').html(data.errorMessage);

            setTimeout(function () {
                if ($giftCertBalanceMsg.hasClass('alert-danger')) {
                    $giftCertBalanceMsg.addClass('d-none');
                }
            }, 5000);
        } else {
            $giftCertBalanceMsg
                .addClass('alert-info')
                .removeClass('alert-danger')
                .find('.resultMessage')
                .html(data.balanceMessage)
                .removeClass('d-none');
        }
    });
});

